import React from 'react';
import { css } from 'aphrodite';
import styles from './content-row-styles';
import {FiChevronDown} from 'react-icons/fi';

const ContentRowView = (props) => (
  <div onClick={props.onClick} className={css(styles.root, !props.onClick && styles.noHover)} style={{width: '100%', ...props.style}}>
    {props.children}
    {props.expandable && <FiChevronDown className={css(styles.expandIcon, props.expanded && styles.expandedIcon)} />}
  </div>
);

export default ContentRowView



// WEBPACK FOOTER //
// ./src/components/common/content-row/content-row-view.js